import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Centralized authenticated fetch for non-axios calls (file uploads, SSE streams).
// All manual fetch() calls route through here so auth lives in ONE place —
// a future httpOnly-cookie migration only needs to change this function.
export const apiFetch = (path, options = {}) => {
  const token = localStorage.getItem("sg_token");
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(`${API}${path}`, { ...options, headers });
};

export default api;
